import {
  IconComfortHeightFloor16,
  IconComfortRenovation16,
  IconFinanceArrowBoldDown16,
  IconFinanceArrowBoldUp16,
  IconFinancePieChart16,
  IconFinanceSale16,
  IconFunctionalCalendar16,
  IconMapPin16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface IMapperProps {
  icon?: string | null;
}

export const Mapper = ({ icon }: IMapperProps) => {
  switch (icon) {
    case 'IconFunctionalCalendar16':
      return <IconFunctionalCalendar16 color="icon-main-default" />;

    case 'IconFinanceArrowBoldDown16':
      return <IconFinanceArrowBoldDown16 color="icon-main-default" />;

    case 'IconComfortRenovation16':
      return <IconComfortRenovation16 color="icon-main-default" />;

    case 'IconFinancePieChart16':
      return <IconFinancePieChart16 color="icon-main-default" />;

    case 'IconMapPin16':
      return <IconMapPin16 color="icon-main-default" />;

    case 'IconFinanceSale16':
      return <IconFinanceSale16 color="icon-main-default" />;

    case 'IconComfortHeightFloor16':
      return <IconComfortHeightFloor16 color="icon-main-default" />;

    case 'IconFinanceArrowBoldUp16':
      return <IconFinanceArrowBoldUp16 color="icon-main-default" />;

    default:
      return null;
  }
};
